<template>
  <div class="tw-flex tw-flex-col tw-w-full tw-h-full tw-bg-gray-900 tw-text-gray-200">
    <h1 class="tw-text-2xl tw-font-bold tw-p-4">Client Explorer</h1>
    <div class="tw-flex tw-flex-row tw-h-full">
      <Sidebar class="tw-w-60 tw-flex-shrink-0"/>
      <div class="tw-flex tw-flex-grow tw-overflow-hidden">
        <ClientExplorerList class="tw-w-1/2 tw-overflow-y-auto"/>
        <ClientExplorerDetail 
          v-if="clientExplorerStore.selectedEntity" 
          class="tw-w-1/2 tw-bg-gray-800 tw-border-l tw-border-gray-700 tw-overflow-y-auto tw-transition-all tw-duration-300 tw-ease-in-out"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './ClientExplorerSidebar.vue';
import ClientExplorerList from './ClientExplorerList.vue';
import ClientExplorerDetail from './ClientExplorerDetail.vue';
import { mapStores } from 'pinia';
import { useClientExplorerStore } from '@frontend/ui/stores/clientExplorerStore';

export default {
  name: "client-explorer",
  components: { Sidebar, ClientExplorerList, ClientExplorerDetail },
  computed: {
    ...mapStores(useClientExplorerStore)
  },
  mounted() {
    console.log('ClientExplorer mounted');
    this.clientExplorerStore.fetchEntities(['Client']);
  },
  watch: {
    'clientExplorerStore.isLoading'(newValue) {
      console.log('isLoading changed:', newValue);
    },
    'clientExplorerStore.results'(newValue) {
      console.log('results changed:', newValue);
    }
  },
  provide() {
    return {
      getClientExplorerStore: () => this.clientExplorerStore
    };
  }
};
</script>